import * as React from 'react';

import TableCell from './TableCell';

interface Props extends React.HTMLAttributes<HTMLTableRowElement> {
    cells?: React.ReactNode[];
    children?: React.ReactNode;
    mouseDown?: string;
}

const TableRow = React.forwardRef<HTMLTableRowElement, Props>(({ cells = [], children, mouseDown, ...rest }, ref) => {
    const childrenWithProps = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child as React.ReactElement<any>, { mouseDown });
        }
        return child;
    });
    return (
        <tr ref={ref} {...rest}>
            {childrenWithProps ||
                cells.map((cell, index) => (
                    <TableCell mouseDown={mouseDown} key={index.toString()} id={index.toString()}>
                        {cell}
                    </TableCell>
                ))}
        </tr>
    );
});

export default TableRow;

TableRow.displayName = 'TableRow';
